import React, { useState,Fragment } from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import {  putAPI_Invitation } from '../../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
const AcceptInvitation = ({ isVisible, invitation, toggle, propertyId, handleConnectedVoucher, LoadData }) => {
    let [invitationData, setInvitationData] = useState({
        'invitationId': invitation.invitationId,
        'sellerGroupId': getGroupID(),
        'sellerPropertyId': propertyId,
        'status': '',
        'groupId': invitation.groupId,
        'propertyId': invitation.propertyId,
        'sellFutureVouchers': invitation.sellFutureVouchers,
        'createdBy': 'Admin',
        'type': 'Invite',
        'relationId': invitation.relationId,
        'groups': invitation.groups,
        "propertys": invitation.propertys
    });
    const onAcceptClick = () => {
        invitationData.status = 'Accepted';
        handleInvitationAccept();
        toggle();
    };
    const onRejectClick = () => {
        invitationData.status = 'Rejected';
        AxiosAPI({
            url: `${putAPI_Invitation}`,
            method: 'put',
            data: invitationData
        }).then(res => {
            LoadData();
        });
        toggle();
    };
    const handleInvitationAccept = () => {
        AxiosAPI({
            url: `${putAPI_Invitation}`,
            method: 'put',
            data: invitationData
        }).then(res => {
            LoadData();
            //handleConnectedVoucher(invitationData.invitationId, invitationData.groups, invitation.propertys, invitation.groupId, invitation.propertyId, 'Invite');
        })
            .catch();

    };
    return (
        <div>
            <Modal isOpen={isVisible} toggle={toggle} style={{ maxWidth: '35%' }}>
                <ModalHeader toggle={toggle}>
                    Accept {invitation.propertyName} invitation to sell voucher

                </ModalHeader>
                <ModalBody>
                    Increase your sales by launching your own beautiful voucher store
                    and let your customers purchases gift voucher directly from your website.

                    <p className='my-3'>

                    {invitation.processingFee > 0 && <Fragment> you will share a {invitation.processingFee} % commision with {invitation.propertyName} for every sale</Fragment>}
                    </p>
                </ModalBody>
                <ModalFooter>
                    {/* <Button onClick={onRejectClick}>
                        Reject
                    </Button> */}
                    <Button color="primary" onClick={onAcceptClick}>
                        Ok
                    </Button>
                </ModalFooter>
            </Modal>

        </div >
    );
};
export default AcceptInvitation;
